module.exports = __webpack_public_path__ + "img/矩形2947.5ba097ff.png";